module.exports = {
  ShapeOverlay: {
    PluginName: "Shape Overlay",
    Shape: "Shape",
    Type: "Type",
    Color: "Color",
  },
};
